import { TStates } from '@Managers/StateMachine/StateMachine.types';
import { EWildWheelFeatureStates } from './WildWheelFeatureStates';
import { wildWheelMergeEndResolver, wildWheelEndResolver, wildWheelResultResolver } from './WildWheelFeatureResolvers';

export const WildWheelFeatureStatesDefaults: TStates<EWildWheelFeatureStates> = {
    WILD_WHEEL_HIDDEN: {},
    WILD_WHEEL_START: {},
    WILD_WHEEL_SPIN: {},
    WILD_WHEEL_RESULT: { resolver: wildWheelResultResolver },
    WILD_WHEEL_END: { resolver: wildWheelEndResolver },
    WILD_WHEEL_MERGE_START: {},
    WILD_WHEEL_MERGE_END: { resolver: wildWheelMergeEndResolver }
};
